import { commands } from './commands';
import { markdown } from './markdown';
import ProseMirrorEditorDriver from './ProseMirrorEditorDriver';
export const proseMirror = {
  commands: commands,
  markdown: markdown,
  ProseMirrorEditorDriver: ProseMirrorEditorDriver
};
flarum.reg.add('bizkaitarra-aurrera-editor', 'common/proseMirror', null);